import React, { Component, ReactNode } from 'react';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import autoBindMethods from 'class-autobind-decorator';
import ReactTable from 'react-table';

import { Well } from 'react-bootstrap';

import { ILoanCollateralCaseUpdate } from '../../../interfaces';
import { OptionsStoreClass } from '../../../stores';
import { Loader } from '../../common';

import { caseUpdateColumns } from './Columns';

interface IProps {
  isLoading: boolean;
  // Shares the title's row, as the tables on the other lending tabs do
  newButton?: ReactNode;
  updates: ILoanCollateralCaseUpdate[];
}

interface IInjected extends IProps {
  OptionsStore: OptionsStoreClass;
}

@inject('OptionsStore')
@autoBindMethods
@observer
class CaseUpdatesTable extends Component<IProps> {
  private get injected () {
    return this.props as IInjected;
  }

  @computed
  private get columns () {
    return caseUpdateColumns(this.injected.OptionsStore.loanCollateralCaseUpdateSourceOptions);
  }

  private renderTable () {
    const { isLoading, updates } = this.props;

    if (isLoading) {
      return <Loader />;
    }

    // A case can go a long time without either side reporting, and a case just entered has nothing
    // at all. Say so rather than showing bare column headers.
    if (!updates.length) {
      return <div className='empty'>Nothing has been reported on this case yet.</div>;
    }

    return (
      <ReactTable
        className='-list -no-scroll'
        columns={this.columns}
        data={updates}
        keyField='id'
        minRows={0}
        pageSize={updates.length}
        resizable={false}
        showPagination={false}
        // The API returns both sources in one list, newest first; re-sorting here would only break
        // the ordering the feed is read in
        sortable={false}
      />
    );
  }

  public render () {
    return (
      <Well className='case-updates-list'>
        <h3 className='flex-between'>
          Updates
          {this.props.newButton}
        </h3>
        {this.renderTable()}
      </Well>
    );
  }
}

export default CaseUpdatesTable;
